var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"login_btn",attrs:{"type":"submit","variant":"primary"},on:{"click":function($event){return _vm.goToLoginPage()}}},[_vm._v("Go to Login")])}
var staticRenderFns = []

export { render, staticRenderFns }